<template>
  <CModal :show.sync="show" centered>
    <multiselect v-model="gallery"
                 class="has-tags"
                 :placeholder="$pgettext('uploader.to_upload.select_gallery','Select gallery')"
                 label="name"
                 track-by="id"
                 :options="galleries"
                 group-values="sub"
                 group-label="name"
    />
    <template #footer>
      <CButton size="sm" @click="show = false" color="secondary" v-translate>Close</CButton>
      <CButton size="sm" @click="onSetGallery" color="primary" translate-context="uploader.to_upload" v-translate>
        Set Gallery
      </CButton>
    </template>
  </CModal>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "GallerySelector",
  components: {Multiselect},
  props: {
    available_galleries: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      show: false,
      gallery: null
    }
  },
  computed: {
    galleries() {
      return this.available_galleries.map(gallery => {
        if (!gallery.sub.length) {
          gallery.sub = [{
              id: gallery.id,
              name: gallery.name,
          }]
        }
        return gallery
      })
    }
  },
  emits: ['update'],
  methods: {
    open(gallery) {
      this.show = true
      this.gallery = gallery || null
    },
    onSetGallery() {
      this.$emit('update', this.gallery)
      this.show = false
    }
  }
}
</script>

<style scoped>

</style>